import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TagValues } from "@/model/data/Tag";
import { FetchInstallationNetworkMetricsResData } from "./FetchInstallationsNetworkMetricsResData";
const ENDPOINT = "/network_metrics/installations";

export class FetchInstallationsNetworkMetricsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsNetworkMetricsReqData;

    constructor(payload: FetchInstallationsNetworkMetricsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationNetworkMetricsResData> {
        var res = await this.executeCommand(this.payload);
        return new FetchInstallationNetworkMetricsResData(res);
    }
}

export class FetchInstallationsNetworkMetricsReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    webSocketMetricStartDate: Date = null;
    webSocketMetricEndDate: Date = null;
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
}
